import { Col } from 'components/Col';
import { CustomTextArea } from 'components/CustomTextArea';
import { HelpButton } from 'components/HelpButton';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.descricaoAtividadeDesenvolvida!;
export default function AcoesPedagogicas() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'descricaoAtividadeDesenvolvida',
        etapa: EtapaProjeto.mobilizacao,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  return (
    <Row>
      <Col>
        <CustomTextArea
          label={
            <>
              {language.label(state.projeto.flgInfantil)}
              <HelpButton style={{ margin: '0 8px' }} text={language.tooltip} />
            </>
          }
          placeholder={language.placeholder}
          name='descricaoAtividadeDesenvolvida'
          value={state.projeto.descricaoAtividadeDesenvolvida || ''}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                descricaoAtividadeDesenvolvida: event.target.value,
              },
            });
          }}
          counter={true}
          maxSize={8000}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          minRows={2}
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
